import { useLoaderData } from '@remix-run/react';
import { Carousel, ImageContainer } from '@theprintbar/ui';
import { loader } from '~/routes/_layout/$/_index';

export function InstagramCarouselSkeleton() {
	return (
		<div className="w-64 h-64 bg-grey/10 flex justify-center items-center rounded-3xl mb-3 animate-pulse">
			<svg
				className="w-10 h-10 text-grey/30 "
				aria-hidden="true"
				xmlns="http://www.w3.org/2000/svg"
				fill="currentColor"
				viewBox="0 0 20 18"
			>
				<path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
			</svg>
		</div>
	);
}

export function InstagramCarousel({ carouselKey = 'intagram-carousel' }) {
	const { instagramImages } = useLoaderData<typeof loader>();

	return (
		<Carousel
			carouselKey={carouselKey}
			mousewheel={{
				releaseOnEdges: true,
			}}
			slidesPerView={'auto'}
			slidesOffsetBefore={12}
			breakpoints={{
				1024: {
					slidesOffsetBefore: 22,
				},
			}}
			slides={
				instagramImages
					? instagramImages.map(post => ({
							containerProps: {
								className: 'pb-8 px-1 lg:px-2.5',
								style: { width: 'auto' },
							},
							content: (
								<a href={post.url} target="_blank">
									<ImageContainer image={post} className="h-64 w-64 rounded-3xl mb-3" />
									<p className="text-sm lg:text-base">@{post.handle}</p>
								</a>
							),
					  }))
					: new Array(12).fill('').map(() => ({
							containerProps: {
								className: 'pb-8 px-1 lg:px-2.5',
								style: { width: 'auto' },
							},
							content: (
								<>
									<InstagramCarouselSkeleton />
									<p className="text-sm lg:text-base opacity-0">Loading</p>
								</>
							),
					  }))
			}
		/>
	);
}
